import FJAppConstant from '../../constants/FJAppConstant';
import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig';

const environment = import.meta.env.MODE;

export default {
    resultImageKey: 'ai/export/watermark-remover/',
    originalImageKey: 'ai/input/watermark-remover/',
    historyListType: 33,
    appType: FJAppConstant.WATERMARK_REMOVER,
    currentMenuName: 'ai-watermark-remover',
    freeLimitType: 'watermark-remover',
    notImageBoxDesc: 'watermark-remover-desc',
    notImageBoxTitle: 'watermark-remover-title',
    notImageBoxBgUrl:
        environment === LOCAL
            ? `/public/resource/ai-watermark-remover/bg.png?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/resource/ai-watermark-remover/bg.png?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxVideoUrl:
        environment === LOCAL
            ? `/public/resource/ai-watermark-remover/video.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/resource/ai-watermark-remover/video.mp4?v=${FJVersionConfig.staticPathVersion}`,
};
